import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportSubstitutionSettlementsTypes } from "redux/reducers/Reports/reportSubstitutionSettlements/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SUBSTITUTION_SETTLEMENTS_FILTERS } = reportSubstitutionSettlementsTypes;

export const getReportSubstitutionSettlementsAction = ({ startDate, endDate, station, isPdf = true }) => {
  const token = localStorage.getItem('crm-user');
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/substitution-settlements?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
  const fileName = `Reporte_Sustitucion_liquidaciones_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

  return async (dispatch) => {
    dispatch(startRequestComp('loadingSubstitutionSettlements'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingSubstitutionSettlements'));
    }
  };
};

export const setReportSubstitutionSettlementsFilters = (key = "", value) => ({
  type: SET_SUBSTITUTION_SETTLEMENTS_FILTERS,
  payload: { key, value }
});
